import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const PencilIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 14" },
        React.createElement("path", { d: "M11.3237 6.29968L5.35895 12.2643C5.23432 12.3889 5.07897 12.4784 4.90862 12.5237L1.06714 13.5443C0.696033 13.6429 0.356893 13.3037 0.455533 12.9326L1.47653 9.09153C1.5218 8.92123 1.61126 8.76591 1.73587 8.64131L7.7006 2.67663L11.3237 6.29968ZM13.0615 2.14636L11.8539 0.938719C11.1869 0.271729 10.1055 0.271729 9.43845 0.938719L8.76114 1.61609L12.3842 5.23914L13.0615 4.56177C13.7285 3.89478 13.7285 2.81336 13.0615 2.14636Z" })));
};

export { PencilIcon };
//# sourceMappingURL=PencilIcon.esm.js.map
